import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Image } from 'antd'
import { Parallax } from "react-parallax"
import { FormattedMessage } from 'react-intl'
import './index.less'
import logo from './images/palmatom_white.png'
import agricultureLogo from './images/agricultureLogo.png'
import palmatom from './images/logo.png'
import agriculture from './images/agriculture.jpg'
import agricultureLeft from './images/agriculture_left.png'
import agricultureRight from './images/agriculture_right.png'
class Agriculture extends Component {
  state = {
  }

  paragraphRef = React.createRef()
  imageRef = React.createRef()
  imageTwoRef = React.createRef()
  imgRef = React.createRef()
  imgTwoRef = React.createRef()

  componentDidMount() {
    // window.addEventListener('resize', this.resizeListener)
    // this.resizeListener()
    window.addEventListener('scroll', this.scrollListener)
    this.scrollListener()

    document.body.scrollTop = document.documentElement.scrollTop = 0
  }

  // resizeListener = () => {
  //   let designSize = 1920
  //   let html = document.documentElement
  //   let clientW = html.clientWidth
  //   let htmlRem = clientW * 100 / designSize
  //   if (clientW > 1920) {
  //     html.style.fontSize = '100px'
  //   } else if (clientW < 900) {
  //     html.style.fontSize = htmlRem + 'px'
  //     this.paragraphRef.current.style.top = 0
  //   } else {
  //     html.style.fontSize = htmlRem + 'px'
  //   }
  // }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.resizeListener)
    window.removeEventListener('scroll', this.scrollListener)
  }

  scrollListener = () => {
    let scrollY = window.scrollY
    let innerHeight = window.innerHeight
    let offsetTop1 = this.imageRef.current.offsetTop
    let offsetTop2 = this.imageTwoRef.current.offsetTop
    let offsetTop3 = this.paragraphRef.current.offsetTop
    let scrollYY1 = offsetTop1 - innerHeight
    let scrollYY2 = offsetTop2 - innerHeight
    let scrollYY3 = offsetTop3 - innerHeight
    let clientHeight1 = this.imageRef.current.clientHeight
    let clientHeight2 = this.imageTwoRef.current.clientHeight
    let clientHeight3 = this.paragraphRef.current.clientHeight

    if (scrollY >= scrollYY1 && scrollY <= (scrollYY1 + clientHeight1)) {
      this.imageRef.current.style.top = 50 * (1 - (scrollY - scrollYY1) / clientHeight1) + 'px'
    }
    if (scrollY >= scrollYY2 && scrollY <= (scrollYY2 + clientHeight2)) {
      this.imageTwoRef.current.style.top = 50 * (1 - (scrollY - scrollYY2) / clientHeight2) + 'px'
    }
    if (scrollY >= scrollYY3 && scrollY <= (scrollYY3 + clientHeight3)) {
      this.paragraphRef.current.style.top = 50 * (1 - (scrollY - scrollYY3) / clientHeight3) + 'px'
    }
  }

  onMouseOver = (type) => {
    if (type === 'imgRef') {
      this.imgRef.current.style.transform = 'scale(1.2)'
      this.imgRef.current.style.transition = '1s'
    } else {
      this.imgTwoRef.current.style.transform = 'scale(1.2)'
      this.imgTwoRef.current.style.transition = '1s'
    }
  }

  onMouseOut = (type) => {
    if (type === 'imgRef') {
      this.imgRef.current.style.transform = 'scale(1)'
      this.imgRef.current.style.transition = '1s'
    } else {
      this.imgTwoRef.current.style.transform = 'scale(1)'
      this.imgTwoRef.current.style.transition = '1s'
    }
  }

  render() {
    return (
      <div className="agriculture">
        <Parallax bgImage={agriculture} bgImageStyle={{ width: '100%', height: window.innerWidth * (0.5625) }} strength={400}>
          <div style={{ height: window.innerWidth * (0.5625) }}>
            <div className="palmatomLogo" onClick={() => this.props.history.push('/admin/home')}>
              <Image width="100%" preview={false} src={logo} />
            </div>
            <div className="agricultureLogo">
              <Image width="100%" preview={false} src={agricultureLogo} />
            </div>
          </div>
        </Parallax>

        <div className="paragraph" ref={this.paragraphRef}>
          <div className="logo">
            <div className="logoImg">
              <Image width="100%" preview={false} src={palmatom}></Image>
            </div>
          </div>
          <div className="title"><FormattedMessage id="agriculture.title" /></div>
          <div className="line">——</div>
          <div className="p">
            <span style={{ display: this.props.localeInfo === 'en_US' ? 'block' : 'inline' }}><FormattedMessage id="agriculture.pone" /></span>
            <span style={{ display: this.props.localeInfo === 'en_US' ? 'block' : 'inline' }}><FormattedMessage id="agriculture.ptwo" /></span>
          </div>
        </div>

        <div className="section">
          <div ref={this.imageRef} className="section_part">
            <div className="imgBox" onMouseOver={() => this.onMouseOver('imgRef')} onMouseOut={() => this.onMouseOut('imgRef')}>
              <img ref={this.imgRef} src={agricultureLeft} alt="" />
            </div>
            <div className="text"><FormattedMessage id="agriculture.textone" /></div>
          </div>
          <div ref={this.imageTwoRef} className="section_part">
            <div className="imgBox" onMouseOver={() => this.onMouseOver('imgTwoRef')} onMouseOut={() => this.onMouseOut('imgTwoRef')}>
              <img ref={this.imgTwoRef} src={agricultureRight} alt="" />
            </div>
            <div className="text"><FormattedMessage id="agriculture.texttwo" /></div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    localeInfo: state.localeInfo
  }),
  {}
)(withRouter(Agriculture))
